export let y_base_path = '/';

export function ySetBasePath(path: string) {
    y_base_path = path;
}

export function yPathToUrl(path: string[]) {
    return y_base_path + path.map(encodeURIComponent).join('/');
}

